// Pure doctor-case history + warning logic. No Firebase.
import { categoryForIssue, CATEGORIES, DOCTOR_ISSUE_TYPES } from '../constants';

const norm = (m) => String(m || '').replace(/\D/g, '').slice(-10);
const lc = (s) => String(s || '').trim().toLowerCase();

export const isDoctorIssue = (issueType) =>
    DOCTOR_ISSUE_TYPES.includes(issueType) || categoryForIssue(issueType) === CATEGORIES.PRODUCT;

const productKeys = (t) => [...(t.productNames || []), ...(t.productIds || [])].map(lc).filter(Boolean);

// Complaints that mention any of the given product names/ids.
export const productComplaintSummary = (tickets = [], products = []) => {
    const want = new Set(products.map(lc).filter(Boolean));
    const matched = want.size ? tickets.filter(t => productKeys(t).some(k => want.has(k))) : [];
    return summarize(matched);
};

// Complaints sharing the same batch number.
export const batchComplaintSummary = (tickets = [], batchNumber = '') => {
    const b = lc(batchNumber);
    const matched = b ? tickets.filter(t => lc(t.doctorCase?.batchNumber) === b) : [];
    return summarize(matched);
};

const summarize = (matched) => {
    const issueCounts = {};
    let last = 0;
    matched.forEach(t => {
        issueCounts[t.issueType] = (issueCounts[t.issueType] || 0) + 1;
        if ((t.createdAt || 0) > last) last = t.createdAt || 0;
    });
    const commonIssues = Object.entries(issueCounts).sort((a, b) => b[1] - a[1]).map(([name, count]) => ({ name, count }));
    return { total: matched.length, commonIssues, lastComplaintAt: last || null, tickets: matched };
};

// Prior product/doctor complaints from the same customer (excluding current ticket).
export const customerPriorDoctorComplaints = (tickets = [], mobile, excludeId) => {
    const m = norm(mobile);
    if (!m) return [];
    return tickets.filter(t => t.id !== excludeId && norm(t.mobile) === m && isDoctorIssue(t.issueType));
};

// Warning banners for the doctor section.
export const doctorWarnings = (ticket, allTickets = []) => {
    const warnings = [];
    if (!ticket) return warnings;

    const prior = customerPriorDoctorComplaints(allTickets, ticket.mobile, ticket.id);
    if (prior.length > 0) warnings.push(`Same customer had ${prior.length} previous doctor complaint(s).`);

    const prod = productComplaintSummary(allTickets.filter(t => t.id !== ticket.id), ticket.productNames || []);
    if (prod.total >= 1) warnings.push(`This product has ${prod.total + 1} total complaint(s).`);

    const batch = ticket.doctorCase?.batchNumber;
    if (batch) {
        const b = batchComplaintSummary(allTickets.filter(t => t.id !== ticket.id), batch);
        if (b.total >= 1) warnings.push(`Batch ${batch} has ${b.total + 1} total complaint(s).`);
    }

    if (['Burning Sensation', 'Skin Irritation', 'Product Reaction'].includes(ticket.issueType)) {
        warnings.push('Burning sensation / irritation — treat as URGENT.');
    }
    if (!ticket.doctorCase?.photosUploaded) {
        warnings.push('Customer needs to share photo / details before doctor review.');
    }
    return warnings;
};
